<script>
	export let ratio = 0.5;
	export let leftStyle = "";
	export let rightStyle = "";
</script>

<div class="col-container">
	<div class="col-left" style="width: {ratio * 100}%;{leftStyle}">
		<slot name="left"></slot>
	</div>
	<div class="col-right" style="width: {(1-ratio) * 100}%;{rightStyle}">
		<slot name="right"></slot>
	</div>
</div>

<style>
	.col-container {
		display: flex;
	}
	.col-left, .col-right {
		padding-right: 40px;
	}
	/* 600px, 900px, 1200px, and 1800px */
    @media (max-width: 900px) {
	    .col-container {
		    flex-direction: column;
	    }
        .col-left, .col-right {
            padding-right: 0;
            width: 100% !important;
        }
        .col-right {
	        margin-top: 40px;
        }
    }
</style>
